import { render, staticRenderFns } from "./ticketopen.vue?vue&type=template&id=d4f0c80e&scoped=true"
import script from "./ticketopen.vue?vue&type=script&lang=js"
export * from "./ticketopen.vue?vue&type=script&lang=js"
import style0 from "./ticketopen.vue?vue&type=style&index=0&id=d4f0c80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f0c80e",
  null
  
)

export default component.exports